import { observer } from "mobx-react-lite";
import { useLocation, useNavigate } from "react-router";
import { commaSeperated, getDisplayDate } from "../../utils/functions";
import InstrumentsValueContainer from "../InstrumentsValueContainer/InstrumentsValueContainer";
import infoIcon2 from "../../assets/images/svg/infoIcon2.svg";
import MoneyValueContainer from "../MoneyValueContainer/MoneyValueContainer";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import { homePageRoute } from "../../utils/constants";

const InstrumentDetailsContainer = ({
  storeInstrumentData,
  data,
  id1,
  addDash,
  isInterest,
  unitBased,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const infintiyHoldingsNavigationPath = location?.pathname?.includes(
    homePageRoute
  )
    ? `/${homePageRoute}/instrument/infinity`
    : `/portfolio/instrument/infinity`;

  const handleNavigateToInfinity = () => {
    UserStore.setMesurementId(
      UserStore.infinityHoldingData?.instrument?.measureinstrumentid
    );

    UserStore.setRememberedMeasuredId(UserStore.infinityMesurementId);

    UserStore.setNormalHybirdFlow(true);
    UserStore.setInfinity("1");
    PerformanceStore.setCurrentLoader("fullScreen");
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    UserStore.getInfinityReturns();
    UserStore.populatePortfolio();

    UserStore.setPortfolioPath("", "", true);
    UserStore.setPortfolioPath(
      {
        path: `/${
          location?.pathname?.includes("portfolio")
            ? "portfolio"
            : homePageRoute
        }/instrument/infinity`,
        show: `Infinity Holdings`,
        state: {
          from: `${
            location?.pathname?.includes("portfolio")
              ? "portfolio"
              : homePageRoute
          }`,
        },
      },
      true
    );
    navigate(infintiyHoldingsNavigationPath, {
      state: {
        from: `/${
          location?.pathname?.includes("portfolio")
            ? "portfolio"
            : homePageRoute
        }`,
      },
    });
  };

  return (
    <div className="instr_det_container_out">
      <div className="title_cont">
        {" "}
        <h2 className="value_det_title">{data?.instrument?.name}</h2>{" "}
        {UserStore.isHybridNormalInstrument && UserStore.isInfinity === "0" && (
          <></>
        )}{" "}
      </div>
      {
        <div className="infinity_hodling_btn_wrapper2">
          <div className="inst_det_money_cont_1">
            <MoneyValueContainer
              title={`Current Value as on ${getDisplayDate(
                data?.investmentreturn?.as_of_date || ""
              )}`}
              amount={`${
                commaSeperated(data?.investmentreturn?.current_value.value) ||
                "-"
              } `}
              unitType={data?.investmentreturn?.current_value.value_type || ""}
            />

            <MoneyValueContainer
              title={`Total Returns (IRR)`}
              infoLogo={infoIcon2}
              amount={`${
                commaSeperated(data?.investmentreturn?.total_returns.value) ||
                "-"
              }`}
              unitType={data?.investmentreturn?.total_returns.value_type}
              amtPercentage={`${data?.investmentreturn?.irr || "-"}`}
              TooltipContent={
                <div className="irr_tip tip_align">
                  <h2>Total Returns</h2>
                  <p>(Realised + Unrealised + Int/Div and Other Income)</p>
                </div>
              }
              tipClass="subAssetLevel"
            />

            {storeInstrumentData?.row1Data?.map((eachData, index) => {
              return (
                <MoneyValueContainer
                  key={index}
                  title={eachData.title}
                  infoLogo={eachData.infoLogo}
                  amount={eachData.amount}
                />
              );
            })}
          </div>
          <div className="wrapper2">
            {!UserStore.isHybridNormalInstrument ||
            UserStore.isInfinity === "1" ? (
              <></>
            ) : (
              <div className="infinity_hodling_btn_wrapper">
                <div className="view_infinity_holdings_btn blueTextColor">
                  <button onClick={handleNavigateToInfinity}>
                    View Infinity Holdings
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      }

      <div className="value_container_wrapperer">
        <InstrumentsValueContainer
          data={data}
          addDash={addDash}
          isInterest={isInterest}
          unitBased={unitBased}
        />
      </div>
    </div>
  );
};

export default observer(InstrumentDetailsContainer);
